import lodashCloneDeep from 'lodash/cloneDeep'

export const clearFinishedActionType = 'clearFinishedActionType';

export function clearFinishedAction() {
    return {
        type: clearFinishedActionType,
    }
}

export function clearFinishedHandler(state, action) {
    let newState = lodashCloneDeep(state);
    newState.queue = newState.queue.filter(queueItem => queueItem.status != 'finished');
    return newState;
}
